// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Avs_","resendInfoText":"OnGoingPaymentBox_resendInfoText__2HSIV"};